export default class DocumentDto {
    constructor(obj) {
        this.name = obj.name
        this.url = obj.url
        this.size = obj.size
        this.updateDate = obj.updateDate
    }
}